// extracted by mini-css-extract-plugin
export default {"hasLeftAttachment":"by2jolTFld","hasRightAttachment":"UOSzZy_tSP","hasTopAttachment":"QzYbWaQCrB","hasBottomAttachment":"RFCkBCgJkr"};